import React from "react";
import { Link } from "react-router-dom";
import { XCircle } from "lucide-react";
import { Button } from "@/components/ui/button";

const PaymentCancel = () => (
  <main data-testid="payment-cancel-page" className="min-h-screen flex items-center justify-center bg-background p-6">
    <div className="max-w-md w-full rounded-2xl border border-border bg-card p-8 text-center shadow-lg">
      <XCircle size={48} className="text-muted-foreground mx-auto" />
      <div className="mt-4 font-serif-display text-3xl">Payment cancelled</div>
      <div className="mt-2 text-sm text-muted-foreground">
        No charges were made. You can return to the portal to try again whenever you're ready.
      </div>
      <div className="mt-6 flex flex-col gap-2">
        <Button asChild className="rounded-full bg-primary text-primary-foreground">
          <Link to="/portal">Back to Parent Portal</Link>
        </Button>
        <Button asChild variant="ghost" className="rounded-full">
          <Link to="/">Back to home</Link>
        </Button>
      </div>
    </div>
  </main>
);

export default PaymentCancel;
